



























import Vue from 'vue';
import format from 'date-fns/format';
import min from 'date-fns/min';
import { defineComponent, ref, watch, Ref, onMounted } from '@vue/composition-api';
import { LabelValue } from '../../abstractions';
import mobiscroll from '../../mobiscroll/js/scroller.javascript';

const componentName = 'wok-mobile-picker-range';

export default defineComponent({
    name: componentName,

    props: {
        value: {
            type: Number,
            default: 0
        },
        minValue: {
            type: Number,
            required: true
        },
        maxValue: {
            type: Number,
            required: true
        },
        step: {
            type: Number,
            default: 1
        },
        pickerLabel: {
            type: String,
            default: ''
        },
        cancelLabel: {
            type: String,
            default: 'Cancel'
        },
        confirmLabel: {
            type: String,
            default: 'Confirm'
        },
        locale: {
            default: undefined
        }
    },

    setup(props, context) {
        const scroller = ref() as Ref<HTMLDivElement>;

        const numbers = new Array<number>();

        for (let i = props.minValue ; i <= props.maxValue ; props.step) {
            numbers.push(i);
        }

        let lastSelectedValue = props.value;
        let scrollerInstance: any = null;

        onMounted(() => {
            scrollerInstance = (<any>mobiscroll).scroller(scroller.value, {
                display: 'inline',
                width: 150,
                showLabel: false,
                wheels: [
                    [{
                        circular: false,
                        data: numbers
                    }]
                ],
                formatValue: function (data: [number]) {
                    return data.toString();
                },
                parseValue: function (valueText: string) {
                    return [parseInt(valueText)];
                },
                onChange: (evt: { valueText: string }) => {
                    lastSelectedValue = parseInt(evt.valueText);
                }
            });
            scrollerInstance.setVal([props.value]);
        });

        watch(() => props.value, value => {
            scrollerInstance?.setVal([value]);
        });

        const onConfirm = () => {
            if (props.value != lastSelectedValue) {
                context.emit('input', lastSelectedValue);
            }
        }

        const onRequestHidePicker = () => {
            context.emit('hide-picker');
        }

        return {
            scroller,
            onConfirm,
            onRequestHidePicker
        }
    }
})
